import AppForm from '../app-components/Form/AppForm';

import { Slovak as DatePickerLocaleSk } from "flatpickr/dist/l10n/sk.js";
import { Czech as DatePickerLocaleCs } from "flatpickr/dist/l10n/cs.js";
const userLanguage = document.documentElement.lang;

Vue.component('user-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                email:  '' ,
                email_verified_at:  '' ,
                password:  '' ,
                first_name:  '' ,
                last_name:  '' ,
                activated:  false ,
                forbidden:  false ,
                language:  '' ,
            },
            datetimePickerConfig: {
                locale: this.getDatePickerLocale(userLanguage)
            }
        }
    },
    methods: {
        getDatePickerLocale(langCode) {
            if(langCode == 'sk') return DatePickerLocaleSk;

            if(langCode == 'cs') return DatePickerLocaleCs;
            
            return null;
        }
    }

});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/user/Form.js